<template>
    <div class="c-PhCode">
        <div class="c-PhCode__container">
            <span :class="'custom-select phone-code__region' + (disable || disableCountryCode ? ' disabled' : '')" @click="triggerCntryCode">
                <span v-if="selectedCountry" class="c-PhCode__cntry-code-flag">
                    <img class="option__image" style="display:none" :src="'/assets/img/flags/'+selectedCountry.falgFileName" :alt="selectedCountry.newCode">
                    <span>+{{selectedCountry.isdCode}}</span>
                </span>
            </span>
            <input :id="inputId" type="tel" :disabled="disable" class="o-Form-control phone-code__number" v-model.trim="telNumber" :maxlength="lengthLimit" @change="changeEvent" @paste="onPaste">
        </div>
        <multiselect v-model="selectedCountry" :open-direction="'above'" v-show="show" :ref="refName" @close="hideCntrCode"
            placeholder="Type to filter" label="title" @select="hideCntrCode();" :allow-empty="false"
            :track-by="trackBy" :options="allCountries" :option-height="104" :max-height="maxHeight"
            :custom-label="customLabel" :show-labels="false" :disabled="disableCountryCode">
            <template slot="singleLabel" slot-scope="props">
                <span class="c-PhCode__cntry-code-flag" v-if="props.option.country !== 'split'">
                    <img class="option__image" :src="'/assets/img/flags/'+props.option.falgFileName" :alt="props.option.newCode">
                    <span>{{ props.option.country }} (+{{props.option.isdCode}})</span>
                </span>
                <span class="c-PhCode__cntry-code-flag" v-else-if="props.option.country == 'split'">- - - - - - - - - - - - - - - - - - -</span>
            </template>
            <template slot="option" slot-scope="props">
                <span class="c-PhCode__cntry-code-flag" v-if="props.option.country !== 'split'">
                    <img class="option__image" :src="'/assets/img/flags/'+props.option.falgFileName" :alt="props.option.newCode">
                    <span class="option__title">{{ props.option.country }} (+{{props.option.isdCode}})</span>
                </span>
                <span class="c-PhCode__cntry-code-flag" v-else-if="props.option.country == 'split'">- - - - - - - - - - - - - - - - - - -</span>
            </template>
        </multiselect>
        <input type="hidden" :name="name" v-model="constructedNumber">
    </div>
</template>

<script>
import Vue from 'vue';
import Multiselect from 'vue-multiselect'

export default {
    components: {
        Multiselect
    },
    props: {
        allCountries: {
            type: Array,
            required: true,
            default: () => []
        },
        defaultVal: {
            type: String,
            required: false
        },
        refName: {
            type: String,
            required: true
        },
        disable: {
            type: Boolean,
            default: false
        },
        trackBy: {
            type: String,
            default: 'newCode',
            required: false
        },
        maxHeight: {
            type: Number,
            default: 300
        },
        changeMethod: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        disableCountryCode: {
            type: Boolean,
            default: false
        },
        lengthLimit: {
            type: Number,
            default: 20
        },
        inputId: {
            type: String,
            default: 'phoneNumberInput'
        }
    },
    data () {
        return {
            selectedCountry: null,
            default: {"country":"United States","newCode":"USA","isdCode":"1","falgFileName":"united-states.jpg","unified": "United State USA 1"},
            show: false,
            telNumber: '',
            constructedNumber: '',
            lastEmittedValue: null
        }
    },
    created () {
        if (!this.defaultVal) {
            this.selectedCountry = JSON.parse(JSON.stringify(this.default));
        } else {
            this.constructTelNumb();
        }
    },
    watch: {
        'telNumber' (val) {
            if (this.applyTypedIsdCode(val)) {
                return;
            }
            const limitedPhoneNumber = this.limitPhoneNumberDigits(val);
            if (limitedPhoneNumber !== val) {
                this.telNumber = limitedPhoneNumber;
                return;
            }
            this.hideCntrCode();
        },
        defaultVal (val) {
            if (!val) {
                this.telNumber = '';
                this.removeStoredPhoneDisplay();
                // this.selectedCountry = JSON.parse(JSON.stringify(this.default));
            }
            else if (val === this.lastEmittedValue) {
                this.constructedNumber = val;
            }
            else if (val) {
                this.constructTelNumb();
            }
        },
        selectedCountry: {
            deep: true,
            handler: function () {
                if (this.$parent && typeof this.$parent?.changeCountry === 'function') {
                    this.$emit('change-country', this.selectedCountry);
                }
            }
        }
    },
    methods: {
        constructTelNumb() {
            this.constructedNumber = this.defaultVal;
            const { isdCode, phoneNumber } = this.extractIsdNPhoneNumber(this.defaultVal);
            this.telNumber = phoneNumber;
            if (isdCode && isdCode.toString() != '1') {
                for (let i = 0; i < this.allCountries.length; i++) {
                    const country = this.allCountries[i];
                    if (country.isdCode === isdCode) {
                        this.selectedCountry = country;
                        break;
                    }
                }
            } else if (!isdCode || (isdCode && isdCode.toString() === '1')) {
                this.selectedCountry = JSON.parse(JSON.stringify(this.default));
            }
            this.restorePhoneDisplay();
        },
        customLabel ({ country, newCode }) {
            return `${country} – ${newCode}`
        },
        showCountryCode () {
            if (!this.disable) {
                this.show = true;
                this.$refs[this.refName].activate();
            }
        },
        hideCntrCode () {
            setTimeout(() => {
                this.show = false;
                const normalizedPhoneNumber = this.normalizePhoneNumber(this.telNumber);
                if (this.selectedCountry && this.selectedCountry.isdCode && normalizedPhoneNumber) {
                    this.constructedNumber = `+${this.selectedCountry.isdCode}-${normalizedPhoneNumber}`;
                // } else if(this.selectedCountry && this.selectedCountry.isdCode) {
                //     this.constructedNumber = `+${this.selectedCountry.isdCode}-`;
                } else {
                    this.constructedNumber = '';
                }
                this.lastEmittedValue = this.constructedNumber;
                this.storePhoneDisplay(this.constructedNumber);
                this.$emit('input', this.constructedNumber);
                this.$emit('change', this.constructedNumber);
                this.$emit('change-tel-number', normalizedPhoneNumber);
            }, 120);
        },
        applyTypedIsdCode (phoneNumber) {
            if (!phoneNumber || phoneNumber.indexOf('+') !== 0) {
                return false;
            }

            const leadingDigits = phoneNumber.substring(1).match(/^\d+/);
            if (!leadingDigits) {
                return true;
            }

            const country = this.allCountries
                .filter(country => country.country !== 'split' && country.isdCode)
                .sort((a, b) => String(b.isdCode).length - String(a.isdCode).length)
                .find(country => leadingDigits[0].indexOf(String(country.isdCode)) === 0);

            // Wait for the user to finish a valid one-to-three digit ISD code.
            if (!country) {
                return true;
            }

            this.selectedCountry = country;
            this.telNumber = phoneNumber
                .substring(String(country.isdCode).length + 1)
                .replace(/^[\s-]+/, '');
            return true;
        },
        normalizePhoneNumber (phoneNumber) {
            // A leading +<ISD> is removed by applyTypedIsdCode. Preserve any
            // remaining plus sign so the phone-format validator can reject it.
            return phoneNumber ? String(phoneNumber).replace(/[()\s]/g, '') : '';
        },
        limitPhoneNumberDigits (phoneNumber) {
            if (!this.lengthLimit || !phoneNumber) {
                return phoneNumber;
            }

            let numberOfDigits = 0;
            return String(phoneNumber).split('').filter(character => {
                if (!/\d/.test(character)) {
                    return true;
                }
                numberOfDigits += 1;
                return numberOfDigits <= this.lengthLimit;
            }).join('');
        },
        getPhoneDisplayStorageKey () {
            const application = window.ibJS && window.ibJS.application ? window.ibJS.application : {};
            const applicationId = application.id || application.applicationId || application.quoteId || window.location.pathname;
            return `phoneCodeDisplay:${applicationId}:${this.name || this.inputId}`;
        },
        storePhoneDisplay (normalizedValue) {
            try {
                const key = this.getPhoneDisplayStorageKey();
                if (!this.telNumber || !normalizedValue) {
                    window.sessionStorage.removeItem(key);
                    return;
                }
                window.sessionStorage.setItem(key, JSON.stringify({
                    normalizedValue,
                    displayValue: this.telNumber
                }));
            } catch (e) {}
        },
        restorePhoneDisplay () {
            try {
                const storedValue = JSON.parse(window.sessionStorage.getItem(this.getPhoneDisplayStorageKey()));
                if (storedValue && storedValue.normalizedValue === this.defaultVal && storedValue.displayValue) {
                    this.telNumber = storedValue.displayValue;
                }
            } catch (e) {}
        },
        removeStoredPhoneDisplay () {
            try {
                window.sessionStorage.removeItem(this.getPhoneDisplayStorageKey());
            } catch (e) {}
        },
        extractIsdNPhoneNumber (defaultVal) {
            let phoneNo = defaultVal;
            let phoneNumber = null;

            let list = phoneNo.indexOf('-') > -1 && phoneNo.indexOf('+') === 0 ? phoneNo.split('-') : null;
            let isdCode = null;
            if (list) {
                isdCode = list[0].substring(1);
            list = list.splice(1);
            }

            if (list) phoneNumber = list.join('-');
            else phoneNumber = phoneNo;

            return {
                isdCode,
                phoneNumber
            }
        },
        changeEvent () {
            if (this.changeMethod) {
                this.$emit(this.changeMethod, this.constructedNumber);
            }
        },
        onPaste (evt) {
            setTimeout(()=>{
                let phnNo = this.telNumber;
                if (phnNo.indexOf('+') === 0) {
                    const rgxCode = phnNo.match(/(\+\d{1,}\s.*?)/);
                    if (rgxCode && rgxCode.length) {
                        const countryCode = rgxCode[0].trim();
                        const ccwithoutplus = countryCode.replace('+','');
                        for (let i = 0; i < this.allCountries.length; i++) {
                            const country = this.allCountries[i];
                            if (country.isdCode === ccwithoutplus) {
                                this.selectedCountry = country;
                                break;
                            }
                        }
                        const newPhnNo = phnNo.replace(countryCode,'').replace(/\D/g, '');
                        this.telNumber = newPhnNo;
                    }
                }
            },150)
        },
        triggerCntryCode () {
            if (!this.disableCountryCode) {
                !this.show ? this.showCountryCode() : this.hideCntrCode();
            }
        }
    }
}
</script>

<style scoped>
    .c-PhCode {
        position: relative;
    }

    .custom-select {
        display: block;
        max-width: 100%;
        width: 100%;
        height: calc(2.25rem + 2px);
        padding: .375rem 1.75rem .375rem .75rem;
        font-weight: 600;
        line-height: 1.25;
        color: #333;
        cursor: pointer;
        vertical-align: middle;
        background: #fff url("/assets/img/bndashboard/svg/select-dropdown.svg") no-repeat right .75rem center;
        background-image: url("/assets/img/bndashboard/svg/dropdown_arrow_down-gray.svg");
        background-size: 8px 10px;
        border: 1px solid rgba(0, 0, 0, .15);
        border-radius: 2px;
        -moz-appearance: none;
        -webkit-appearance: none;
    }
    .c-PhCode .multiselect__element {
        font-size: 13px;
        /* padding: 6px; */
    }
    .c-PhCode__cntry-code-flag {
        display: flex;
        align-items: center;
        font-size: .75rem;
    }
    .c-PhCode__cntry-code-flag img {
        border: 1px solid #e0e0e0;
        width: 1.25rem;
        margin-right: 0.5em;
    }
    .c-PhCode__cntry-code-flag span:last-child {
        line-height: 0;
    }
    .c-PhCode__container {
        display: flex;
        flex-flow: row nowrap;
        align-items: flex-start;
        justify-content: flex-start;
    }

    .c-PhCode__container .custom-select {
        width: auto !important;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 0 !important;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        height: 2.38rem;
    }

    #request-call-back-phone-code .c-PhCode__container .custom-select {
        height: 26px;
    }

    .c-PhCode__container .o-Form-control {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .c-PhCode .multiselect {
        position: absolute;
        width: 100%;
        top: 2.38rem;
        left: 0;
    }

    .c-PhCode .multiselect__tags {
        border-top: 0;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
    }

    .c-PhCode .multiselect--active {
        border: 0;
    }

    .c-PhCode .multiselect__option {
        min-height: auto;
        line-height: .75;
        padding: 6px;
    }

    .multiselect__option--disabled {
        background: #fff;
        color: #555;
    }

    .phone-code__number {
        border-radius: 0px 4px 4px 0px !important;
        color: #555;
    }

    .phone-code__number:disabled {
        background: #f4f4f4;
        border: 1px solid #e5e5e5;
        cursor: default;
    }

    .phone-code__region {
        border-radius: 4px 0px 0px 4px !important;
        color: #555;
        font-weight: 500;
    }

    .phone-code__region.disabled {
        background: #f4f4f4;
        border-left: 1px solid #e5e5e5;
        border-top: 1px solid #e5e5e5;
        border-bottom: 1px solid #e5e5e5;
        cursor: default;
        color: #555;
    }
    
</style>
